// Archief/Fields/algorithm/stopTimeFilter.js

// Assuming moment-timezone is available in the project, as used elsewhere
const moment = require('moment-timezone');

// Import necessary helpers (adjust path if tableHelpers.js is elsewhere)
// Or redefine shifts, parseTime, getMealTypeByTime here if preferred
const { shifts, parseTime, getMealTypeByTime } = require('../tableHelpers');

/**
 * Gets the current time in minutes since midnight in the Brussels timezone.
 * @returns {number} Current time in minutes.
 */
function getCurrentTimeInBrusselsMinutes() {
    const now = moment().tz('Europe/Brussels');
    return now.hours() * 60 + now.minutes();
}

/**
 * Filters a list of timeblocks based on stop times defined in general settings.
 * This filter only applies if the provided dateStr is the current date.
 *
 * @param {Object} timeblocks - An object where keys are time strings ("HH:MM") and values are timeblock data.
 * @param {Object} restaurantData - The main restaurant data object containing general-settings.
 * @param {string} dateStr - The date string ("YYYY-MM-DD") to check against today.
 * @returns {Object} - The filtered timeblocks object.
 */
function filterTimeblocksByStopTimes(timeblocks, restaurantData, dateStr) {
    // Determine today's date string in the correct timezone
    const todayStr = moment().tz('Europe/Brussels').format('YYYY-MM-DD');

    // Only apply the filter if the date being checked is today
    if (dateStr !== todayStr) {
        return timeblocks; // No filtering needed for future dates
    }

    console.log(`Applying stop time filter for today (${dateStr})`);

    const settings = restaurantData?.['general-settings'] || {};
    const currentTimeMinutes = getCurrentTimeInBrusselsMinutes();

    // Get stop times from settings and parse them (handle missing/null values)
    const breakfastStopTimeStr = settings.ontbijtStop || null; // e.g., "10:00"
    const lunchStopTimeStr = settings.lunchStop || null;     // e.g., "14:00"
    const dinnerStopTimeStr = settings.dinerStop || null;    // e.g., "20:00"

    const breakfastStopTime = breakfastStopTimeStr ? parseTime(breakfastStopTimeStr) : null;
    const lunchStopTime = lunchStopTimeStr ? parseTime(lunchStopTimeStr) : null;
    const dinnerStopTime = dinnerStopTimeStr ? parseTime(dinnerStopTimeStr) : null;

    // console.log(`Current time (minutes): ${currentTimeMinutes}`); // Verbose
    // console.log(`Stop times (minutes) - Breakfast: ${breakfastStopTime}, Lunch: ${lunchStopTime}, Dinner: ${dinnerStopTime}`); // Verbose

    const filteredTimeblocks = {};
    let skippedBreakfast = 0;
    let skippedLunch = 0;
    let skippedDinner = 0;

    for (const time in timeblocks) {
        if (!timeblocks.hasOwnProperty(time)) continue;

        const mealType = getMealTypeByTime(time);
        let skip = false;

        if (mealType === 'breakfast' && breakfastStopTime !== null && !isNaN(breakfastStopTime) && currentTimeMinutes >= breakfastStopTime) {
            skip = true;
            skippedBreakfast++;
        } else if (mealType === 'lunch' && lunchStopTime !== null && !isNaN(lunchStopTime) && currentTimeMinutes >= lunchStopTime) {
            skip = true;
            skippedLunch++;
        } else if (mealType === 'dinner' && dinnerStopTime !== null && !isNaN(dinnerStopTime) && currentTimeMinutes >= dinnerStopTime) {
            skip = true;
            skippedDinner++;
        }

        if (!skip) {
            filteredTimeblocks[time] = timeblocks[time];
        }
    }

    if (skippedBreakfast > 0) console.log(`Stop time filter removed ${skippedBreakfast} breakfast slots.`);
    if (skippedLunch > 0) console.log(`Stop time filter removed ${skippedLunch} lunch slots.`);
    if (skippedDinner > 0) console.log(`Stop time filter removed ${skippedDinner} dinner slots.`);

    return filteredTimeblocks;
}

module.exports = {
    filterTimeblocksByStopTimes
};